// extracted by mini-css-extract-plugin
module.exports = {"focused":"Popup_focused__3hzJi","popupContainer":"Popup_popupContainer__fYxvY","closeBtn":"Popup_closeBtn__2QOhb"};